{
    "Profile_Drivers_Driver.name": "FR: Name",
    "Profile_Drivers_Driver.person": "FR: Person",
    "Profile_Drivers_Driver.driverDetails": "FR: Driver Details",
    "Profile_Drivers_Driver.number": "FR: Number",
    "Profile_Drivers_Driver.applicant": "FR: Applicant",
    "Profile_Drivers_Driver.relationshipToApplicant": "FR: Relationship to Applicant",
    "Profile_Drivers_Driver.yearsContinuouslyInsured": "FR: Years Continuously Insured",
    "Profile_Drivers_Driver.yearsWithPreviousInsurer": "FR: Years With Previous Insurer",
    "Profile_Drivers_Driver.yearsAtCurrentAddress": "FR: Years at Current Address",
    "Profile_Drivers_Driver.driverTraining": "FR: Driver Training",
    "Profile_Drivers_Driver.outOfCountryExperience": "FR: Out of Country Experience",
    "Profile_Drivers_Driver.numberOfClaims": "FR: Number of Claims",
    "Profile_Drivers_Driver.timeframeOfClaims": "FR: Timeframe of Claims",
    "Profile_Drivers_Driver.licenseDetails": "FR: License Details",
    "Profile_Drivers_Driver.ageFirstLicensed": "FR: Age First Licensed",
    "Profile_Drivers_Driver.issuingCountry": "FR: Issuing Country",
    "Profile_Drivers_Driver.issuingProvince": "FR: Issuing Province",
    "Profile_Drivers_Driver.licenseNumber": "FR: License Number",
    "Profile_Drivers_Driver.licenseClass": "FR: License Class",
    "Profile_Drivers_Driver.issuedDate": "FR: Issued Date",
    "Profile_Drivers_Driver.numberOfConvictions": "FR: Number of Convictions",
    "Profile_Drivers_Driver.timeframeOfConvictions": "FR: Timeframe of Convictions",
    "Profile_Drivers_Driver.drivingConvictions": "FR: Driving Convictions",
    "Profile_Drivers_Driver.drivingSuspensions": "FR: Driving Suspensions",
    "Profile_Drivers_Driver.criminalConvictions": "FR: Criminal Convictions",
    "Profile_Drivers_Driver.claims": "FR: Claims",
    "Profile_Drivers_Driver.cancellations": "FR: Cancellations",
    "Profile_Drivers_Driver.newConviction": "FR: New Conviction",
    "Profile_Drivers_Driver.newSuspension": "FR: New Suspension",
    "Profile_Drivers_Driver.newCriminalConviction": "FR: New Criminal Conviction",
    "Profile_Drivers_Driver.newClaim": "FR: New Claim",
    "Profile_Drivers_Driver.newCancellationReason": "FR: New Cancellation Reason",
    "Profile_Drivers_Driver.state": "FR: State"
}
